import { SStyled } from '../../../../styles/theme'
import SBox from '../../../opinionless/SBox'
import theme from '../../../../styles/theme'

export const SingleCardStyledContainer = SStyled(SBox)`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    width: 148px;
    gap: 12px;
    border-radius: 8px;
    border-style: solid;
    border-color: ${theme.colors.secondaryColor};
    border-width: 1px;
    align-items: center;
    height: 72px;
    padding-left: 18px;
    color: ${theme.colors.secondaryColor};
    cursor: pointer;
`
